import { AddressFormNew_MX } from './mixed';
import { AddressFormNew_OL } from './operatingLease';

export const AddressFormNew = {
  /**
   * PrivateLease
   */
  FP: AddressFormNew_MX,
  /**
   * PrivateLease
   */
  PL: AddressFormNew_MX,
  /**
   * ServicePlan for Private
   */
  SP: AddressFormNew_MX,
  /**
   * ServicePlan for Business
   */
  SPB: AddressFormNew_MX,
  /**
   * OperatingLease
   */
  OL: AddressFormNew_OL,
};
